var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "font-size-14" },
    [
      _c(
        "yxt-row",
        { staticClass: "bg-white" },
        [
          _c("yxt-col", [
            _c(
              "div",
              [
                _c(
                  "yxt-form",
                  {
                    ref: "ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "color-gray-9",
                        attrs: {
                          prop: "forceSubmitTime",
                          label: _vm.$t("pc_biz_ote_lbl_examlimit"),
                        },
                      },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            model: {
                              value: _vm.isForceSubmitCtrl,
                              callback: function ($$v) {
                                _vm.isForceSubmitCtrl = $$v
                              },
                              expression: "isForceSubmitCtrl",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_submittime")))]
                        ),
                        _vm.isForceSubmitCtrl
                          ? _c(
                              "span",
                              { staticClass: "ml10" },
                              [
                                _c("yxt-date-picker", {
                                  staticStyle: { width: "440px" },
                                  attrs: {
                                    type: "datetime",
                                    placeholder: _vm.$t(
                                      "pc_biz_ote_tip_submittime"
                                    ),
                                    format: "yyyy-MM-dd HH:mm",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                  },
                                  model: {
                                    value: _vm.ruleForm.forceSubmitTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "forceSubmitTime",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.forceSubmitTime",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "yxt-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: _vm.$t("pc_biz_ote_tip_submittimetip"),
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ml8 v-mid color-gray-9" },
                              [
                                _c("yxt-svg", {
                                  staticClass: "yxtbiz-exam-arrange__tip-icon",
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": "info-cirlce-o",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "color-gray-9",
                        attrs: { prop: "usedTimesLenMin", label: "" },
                      },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            model: {
                              value: _vm.isUsedTimesCtrl,
                              callback: function ($$v) {
                                _vm.isUsedTimesCtrl = $$v
                              },
                              expression: "isUsedTimesCtrl",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_examtimelength"))
                            ),
                          ]
                        ),
                        _vm.isUsedTimesCtrl
                          ? _c(
                              "span",
                              [
                                _c(
                                  "span",
                                  { staticClass: "ml10" },
                                  [
                                    _c("yxt-input", {
                                      directives: [
                                        {
                                          name: "enter-number",
                                          rawName: "v-enter-number",
                                        },
                                      ],
                                      staticStyle: { width: "96px" },
                                      attrs: { maxlength: "3" },
                                      model: {
                                        value: _vm.ruleForm.usedTimesLenMin,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "usedTimesLenMin",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.usedTimesLenMin",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(
                                  "（" +
                                    _vm._s(_vm.$t("pc_biz_ote_lbl_minites")) +
                                    "）"
                                ),
                                _c(
                                  "yxt-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.$t(
                                        "pc_biz_ote_tip_examtimeendsubmit"
                                      ),
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ml8 v-mid color-gray-9" },
                                      [
                                        _c("yxt-svg", {
                                          staticClass:
                                            "yxtbiz-exam-arrange__tip-icon",
                                          attrs: {
                                            width: "16px",
                                            height: "16px",
                                            "icon-class": "info-cirlce-o",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "color-gray-9",
                        attrs: { prop: "repeatTimes" },
                      },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isRepeated,
                              callback: function ($$v) {
                                _vm.isRepeated = $$v
                              },
                              expression: "isRepeated",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_allowrepeat")))]
                        ),
                        _vm.isRepeated
                          ? _c(
                              "span",
                              [
                                _c("yxt-input", {
                                  directives: [
                                    {
                                      name: "enter-number",
                                      rawName: "v-enter-number",
                                    },
                                  ],
                                  staticClass: "mh8",
                                  staticStyle: { width: "96px" },
                                  attrs: {
                                    disabled: _vm.status !== 0,
                                    maxlength: "2",
                                  },
                                  model: {
                                    value: _vm.ruleForm.repeatTimes,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "repeatTimes", $$v)
                                    },
                                    expression: "ruleForm.repeatTimes",
                                  },
                                }),
                                _vm._v(
                                  _vm._s(_vm.$t("pc_biz_ote_lbl_time")) +
                                    "\n                "
                                ),
                                _c(
                                  "yxt-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.$t(
                                        "pc_biz_ote_tip_allowrepeattip"
                                      ),
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "ml8 v-mid color-gray-6" },
                                      [
                                        _c("yxt-svg", {
                                          staticClass:
                                            "yxtbiz-exam-arrange__tip-icon-t2",
                                          attrs: {
                                            width: "16px",
                                            height: "16px",
                                            "icon-class": "info-cirlce-o",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isAllowUpload,
                              callback: function ($$v) {
                                _vm.isAllowUpload = $$v
                              },
                              expression: "isAllowUpload",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_allowuploadattach")
                              ) + "\n              "
                            ),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t(
                                    "pc_biz_ote_lbl_allowuploadattach"
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "ml8 v-mid color-gray-9" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass:
                                        "yxtbiz-exam-arrange__tip-icon",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "info-cirlce-o",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "color-gray-9",
                        attrs: { label: _vm.$t("pc_biz_ote_lbl_marklimit") },
                      },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            model: {
                              value: _vm.isAutoMarkFillin,
                              callback: function ($$v) {
                                _vm.isAutoMarkFillin = $$v
                              },
                              expression: "isAutoMarkFillin",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_fillinautomark")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            model: {
                              value: _vm.isAutoMarkAnswer,
                              callback: function ($$v) {
                                _vm.isAutoMarkAnswer = $$v
                              },
                              expression: "isAutoMarkAnswer",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_answerautomark")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isAnonyMark,
                              callback: function ($$v) {
                                _vm.isAnonyMark = $$v
                              },
                              expression: "isAnonyMark",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_anymousmark")) +
                                "\n              "
                            ),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t("pc_biz_ote_lbl_anymousmark"),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "ml8 v-mid color-gray-9" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass:
                                        "yxtbiz-exam-arrange__tip-icon",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "info-cirlce-o",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isNoAnswerNoMark,
                              callback: function ($$v) {
                                _vm.isNoAnswerNoMark = $$v
                              },
                              expression: "isNoAnswerNoMark",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_notautomarkofnull")
                              ) + "\n              "
                            ),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t("pc_biz_ote_lbl_automarktip"),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "ml8 v-mid color-gray-9" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass:
                                        "yxtbiz-exam-arrange__tip-icon",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "info-cirlce-o",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "color-gray-9",
                        attrs: {
                          label: _vm.$t("pc_biz_ote_lbl_answersetting"),
                        },
                      },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            model: {
                              value: _vm.isAllowViewResultDetail,
                              callback: function ($$v) {
                                _vm.isAllowViewResultDetail = $$v
                              },
                              expression: "isAllowViewResultDetail",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_allowviewanswerdetail")
                              )
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "ml24" }, [
                          _c(
                            "div",
                            [
                              _vm.isAllowViewResultDetail
                                ? _c(
                                    "yxt-checkbox",
                                    {
                                      staticClass: "width-percent-100",
                                      model: {
                                        value:
                                          _vm.isAllowViewResultDetailErrorQues,
                                        callback: function ($$v) {
                                          _vm.isAllowViewResultDetailErrorQues =
                                            $$v
                                        },
                                        expression:
                                          "isAllowViewResultDetailErrorQues",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_ote_lbl_allowviewanswerwrong"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isAllowViewResultDetail
                                ? _c(
                                    "yxt-checkbox",
                                    {
                                      staticClass: "width-percent-100",
                                      model: {
                                        value:
                                          _vm.isAllowViewResultDetailAnswer,
                                        callback: function ($$v) {
                                          _vm.isAllowViewResultDetailAnswer =
                                            $$v
                                        },
                                        expression:
                                          "isAllowViewResultDetailAnswer",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_ote_lbl_allowviewanswer"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isAllowViewResultDetail
                                ? _c(
                                    "yxt-checkbox",
                                    {
                                      staticClass: "width-percent-100",
                                      model: {
                                        value:
                                          _vm.isAllowViewResultDetailExplain,
                                        callback: function ($$v) {
                                          _vm.isAllowViewResultDetailExplain =
                                            $$v
                                        },
                                        expression:
                                          "isAllowViewResultDetailExplain",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_ote_lbl_allowviewanswerdesc"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _vm.isAllowViewResultDetail
                                ? _c(
                                    "yxt-checkbox",
                                    {
                                      model: {
                                        value: _vm.isAllowViewResultDetailTime,
                                        callback: function ($$v) {
                                          _vm.isAllowViewResultDetailTime = $$v
                                        },
                                        expression:
                                          "isAllowViewResultDetailTime",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_ote_lbl_allowviewtimelimit"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "ml24" },
                                [
                                  _vm.isAllowViewResultDetailTime
                                    ? _c("yxt-date-picker", {
                                        staticStyle: { width: "440px" },
                                        attrs: {
                                          type: "datetimerange",
                                          "range-separator":
                                            _vm.$t("pc_biz_ote_lbl_to"),
                                          "start-placeholder": _vm.$t(
                                            "pc_biz_ote_lbl_starttime"
                                          ),
                                          "end-placeholder": _vm.$t(
                                            "pc_biz_ote_lbl_endtime"
                                          ),
                                          format: "yyyy-MM-dd HH:mm",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                        },
                                        model: {
                                          value: _vm.ViewResultDetailTime,
                                          callback: function ($$v) {
                                            _vm.ViewResultDetailTime = $$v
                                          },
                                          expression: "ViewResultDetailTime",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isRandomSort,
                              callback: function ($$v) {
                                _vm.isRandomSort = $$v
                              },
                              expression: "isRandomSort",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_quesnoorder")))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isRandomItemSort,
                              callback: function ($$v) {
                                _vm.isRandomItemSort = $$v
                              },
                              expression: "isRandomItemSort",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quesitemnoorder"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isOnlyPc,
                              callback: function ($$v) {
                                _vm.isOnlyPc = $$v
                              },
                              expression: "isOnlyPc",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_allowexaminpc"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isOnlyMobile,
                              callback: function ($$v) {
                                _vm.isOnlyMobile = $$v
                              },
                              expression: "isOnlyMobile",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_allowexaminh5")) +
                                "\n              "
                            ),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t(
                                    "pc_biz_ote_lbl_h5joindevice"
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "ml8 v-mid color-gray-9" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass:
                                        "yxtbiz-exam-arrange__tip-icon",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "info-cirlce-o",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.isOnlyMobile
                          ? _c(
                              "div",
                              { staticClass: "pl24" },
                              [
                                _c(
                                  "yxt-checkbox",
                                  {
                                    attrs: { disabled: _vm.status !== 0 },
                                    model: {
                                      value: _vm.isOnlyMobileApp,
                                      callback: function ($$v) {
                                        _vm.isOnlyMobileApp = $$v
                                      },
                                      expression: "isOnlyMobileApp",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("pc_biz_ote_lbl_allowexaminapp")
                                      )
                                    ),
                                  ]
                                ),
                                _vm.isOnlyMobileApp && false
                                  ? _c(
                                      "div",
                                      { staticClass: "pl24" },
                                      [
                                        _c(
                                          "yxt-checkbox",
                                          {
                                            attrs: {
                                              disabled: _vm.status !== 0,
                                            },
                                            model: {
                                              value: _vm.isEnabledAfr,
                                              callback: function ($$v) {
                                                _vm.isEnabledAfr = $$v
                                              },
                                              expression: "isEnabledAfr",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_lbl_openface"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", { staticClass: "ml5" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pc_biz_ote_lbl_openfaceshotduration1"
                                              )
                                            )
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "mh8" },
                                            [
                                              _c("yxt-input", {
                                                directives: [
                                                  {
                                                    name: "enter-number",
                                                    rawName: "v-enter-number",
                                                  },
                                                ],
                                                ref: "afrMinCell",
                                                staticStyle: { width: "96px" },
                                                attrs: {
                                                  disabled: _vm.status !== 0,
                                                },
                                                model: {
                                                  value:
                                                    _vm.ruleForm.afrMinCell,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      "afrMinCell",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ruleForm.afrMinCell",
                                                },
                                              }),
                                              _vm._v(" ~ "),
                                              _c("yxt-input", {
                                                directives: [
                                                  {
                                                    name: "enter-number",
                                                    rawName: "v-enter-number",
                                                  },
                                                ],
                                                ref: "afrMaxCell",
                                                staticStyle: { width: "96px" },
                                                attrs: {
                                                  disabled: _vm.status !== 0,
                                                },
                                                model: {
                                                  value:
                                                    _vm.ruleForm.afrMaxCell,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      "afrMaxCell",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ruleForm.afrMaxCell",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pc_biz_ote_lbl_openfaceshotduration2"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isOnlyMobile
                          ? _c(
                              "div",
                              { staticClass: "pl24" },
                              [
                                _c(
                                  "yxt-checkbox",
                                  {
                                    attrs: { disabled: _vm.status !== 0 },
                                    model: {
                                      value: _vm.isOnlyMobileH5,
                                      callback: function ($$v) {
                                        _vm.isOnlyMobileH5 = $$v
                                      },
                                      expression: "isOnlyMobileH5",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_ote_lbl_allowexaminh5web"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    !_vm.oteSwitchScreenStatus.hidden
                      ? _c(
                          "yxt-form-item",
                          { staticClass: "color-gray-9" },
                          [
                            _c(
                              "yxt-checkbox",
                              {
                                attrs: {
                                  disabled:
                                    _vm.status !== 0 ||
                                    _vm.oteSwitchScreenStatus.disabled,
                                },
                                model: {
                                  value: _vm.isForbidExit,
                                  callback: function ($$v) {
                                    _vm.isForbidExit = $$v
                                  },
                                  expression: "isForbidExit",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("pc_biz_ote_lbl_examleavesetting")
                                  )
                                ),
                              ]
                            ),
                            _vm.isForbidExit
                              ? _c("yxt-input", {
                                  directives: [
                                    {
                                      name: "enter-number",
                                      rawName: "v-enter-number",
                                    },
                                  ],
                                  ref: "exitTimes",
                                  staticClass: "mh8 w70",
                                  staticStyle: { width: "96px" },
                                  attrs: {
                                    maxlength: "3",
                                    disabled:
                                      _vm.status !== 0 ||
                                      _vm.oteSwitchScreenStatus.disabled,
                                  },
                                  model: {
                                    value: _vm.ruleForm.exitTimes,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "exitTimes", $$v)
                                    },
                                    expression: "ruleForm.exitTimes",
                                  },
                                })
                              : _vm._e(),
                            _vm.isForbidExit
                              ? _c("span", {}, [
                                  _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_time"))),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.oteLeaveSubmitStatus.hidden
                      ? _c(
                          "yxt-form-item",
                          { staticClass: "color-gray-9" },
                          [
                            _c(
                              "yxt-checkbox",
                              {
                                attrs: {
                                  disabled:
                                    _vm.status !== 0 ||
                                    _vm.oteLeaveSubmitStatus.disabled,
                                },
                                model: {
                                  value: _vm.isMaxLeaveTime,
                                  callback: function ($$v) {
                                    _vm.isMaxLeaveTime = $$v
                                  },
                                  expression: "isMaxLeaveTime",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_ote_lbl_examleavesettingtimelimit1"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c("yxt-input", {
                              directives: [
                                {
                                  name: "enter-number",
                                  rawName: "v-enter-number",
                                },
                              ],
                              ref: "maxLeaveTime",
                              staticClass: "mh8 w70",
                              staticStyle: { width: "96px" },
                              attrs: {
                                maxlength: "3",
                                disabled:
                                  _vm.status !== 0 ||
                                  _vm.oteLeaveSubmitStatus.disabled,
                              },
                              model: {
                                value: _vm.ruleForm.maxLeaveTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "maxLeaveTime", $$v)
                                },
                                expression: "ruleForm.maxLeaveTime",
                              },
                            }),
                            _c("span", {}, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_biz_ote_lbl_examleavesettingtimelimit2"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "yxt-form-item",
                      { staticClass: "color-gray-9" },
                      [
                        _c(
                          "yxt-checkbox",
                          {
                            attrs: { disabled: _vm.status !== 0 },
                            model: {
                              value: _vm.isFixedDevice,
                              callback: function ($$v) {
                                _vm.isFixedDevice = $$v
                              },
                              expression: "isFixedDevice",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_examcantchangedevice")
                              ) + "\n              "
                            ),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t(
                                    "pc_biz_ote_tip_examcantchangedevicetip"
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "ml8 v-mid color-gray-9" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass:
                                        "yxtbiz-exam-arrange__tip-icon",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "info-cirlce-o",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }